import * as React from 'react';
import Tab from './Tab';
import TabProps from './TabProps';
import './TabView.css';

interface Props {
    tabs: TabProps[];
    openTabIds: string[];
    onTabClick: (id: string) => void;
}

const TabView: React.FunctionComponent<Props> = props => {
    const renderTab = (tab: TabProps) => {
        return <Tab
            key={tab.id}
            props={tab}
            isSelected={props.openTabIds.includes(tab.id)}
            onClick={props.onTabClick} />;
    };

    return (
        <div className="TabView">
            <div className="TabView_Group">{props.tabs.filter(tab => !tab.align || tab.align === 'left').map(renderTab)}</div>
            <div className="TabView_Group">{props.tabs.filter(tab => tab.align === 'right').map(renderTab)}</div>
        </div>
    );
};

export default TabView;
